<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="sra-title-wrap">
          <div class="manager-title" v-text="title"></div>
          <Button label="Xuất file excel" :loading="exporting_excel" :disabled="exporting_excel" @click="clickExportExcel()" class="sra-export-btn" />
        </div>
        <!-- <div class="blacklist-action">
          <Button
            label="DS nhân sự blacklist"
            icon="pi pi-exclamation-triangle"
            class="p-button-danger"
            @click="openBlacklistDialog"
          />
        </div> -->
        <DropdownScrollable :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset"/>
        <BaseDatatable
          ref="datatable"
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onEventOptions="onEventOptions"
          @onDataChange = 'DataOnChange'
          :company="company"
        ></BaseDatatable>
        <Dialog
          header="Xuất file excel"
          :visible.sync="showExportDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Số lượng xuất vượt quá {{ export_limit }} dòng. Nếu muốn xuất file thì bấm tiếp tục hoặc bấm hủy để lọc lại và xuất file sau.
          <template #footer>
            <Button label="Hủy" @click="showExportDialog = false" icon="pi pi-times" class="p-button-warning callback-btn" />
            <Button label="Tiếp tục" @click="confirmExportExcel()" icon="pi pi-check" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá gói công việc này khỏi danh sách?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteFixDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá gói công việc này khỏi danh sách? (Bỏ qua điều kiện trạng thái)
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteFixDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteDataFix()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" id="warning_poins_errs">
          <span class="txt-center">
            Bạn không thể xoá khu vực làm việc đang được thực hiện đánh giá.
          </span>
          <template
              #footer
              class="justify-content-center"
            >
            <Button label="Xác nhận" @click="popupWarning = false" icon="pi pi-check" class="" />
          </template>
        </Dialog>
        <Dialog
          header="Danh sách nhân sự vi phạm"
          :visible.sync="showBlacklistDialog"
          :style="{ width: '70vw' }"
          :contentStyle="{ overflow: 'auto' }"
          :modal="true"
        >
          <DataTable
            :value="blacklistData"
            responsiveLayout="scroll"
            :loading="blacklistLoading"
            class="p-datatable-sm"
          >
            <Column header="STT" headerStyle="width: 70px">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column field="fullname" header="Họ và tên"></Column>
            <Column field="id_card" header="CCCD"></Column>
            <Column field="contractor_name" header="Tên nhà thầu"></Column>
            <Column field="sra_name" header="Tên gói SRA"></Column>
          </DataTable>
          <div v-if="!blacklistLoading && blacklistData.length === 0" class="blacklist-empty">
            Không có dữ liệu blacklist.
          </div>
          <template #footer>
            <Button
              label="Đóng"
              icon="pi pi-times"
              class="p-button-secondary"
              @click="showBlacklistDialog = false"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      deleteFixId: null,
      showDeleteFixDialog: false,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      popupWarning: false,
      showBlacklistDialog: false,
      blacklistLoading: false,
      blacklistData: [],
      factory_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      contractor_id : null,
      export_limit: 2000,
      showExportDialog: false,
      exporting_excel: false,
    }
  },
  async created() {
    await this.initParams();
    await this.getListCompany()
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    // console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company = {id: this.$route.query.company_id};
        // setTimeout(() => {
        //   const query = Object.assign({}, this.$route.query);
        //   delete query.company_id;
        //   this.$router.replace({ query });
        // }, 100);
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.contractor_id)){
        this.contractor_id = this.$route.query.contractor_id;
        // setTimeout(() => {
        //     const query = Object.assign({}, this.$route.query);
        //     this.$router.replace({ query });
        // }, 100);
      }
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  mounted () {
    this.loadBlacklistData()
  },
  beforeRouteLeave(to, from, next) {
    // Rời sang trang không thuộc SRA (menu khác...) thì bỏ filter đã lưu
    if (!to.path.startsWith('/admin/list-sra')) {
      try { sessionStorage.removeItem('sra_list_state'); } catch (e) { /* ignore */ }
    }
    next();
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      await this.getListFactory();
      if (!this.$commonFuction.isEmpty(this.$route.query.contractor_id)){
          //gọi detail phiếu
          this.contractor_id = this.$route.query.contractor_id;
          await this.defaultFilter()
          // setTimeout(() => {
          //     const query = Object.assign({}, this.$route.query);
          //     delete query.contractor_id;
          //     this.$router.replace({ query });
          // }, 300);
          this.componentKey++;
      }

      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.componentKey++;
      }
    }
  },
  methods: {
    clickExportExcel() {
      var params = this.$refs.datatable.getExportParams();
      if (params.total > this.export_limit) {
        this.showExportDialog = true;
        return;
      }
      this.exportExcel();
    },
    confirmExportExcel() {
      this.showExportDialog = false;
      this.exportExcel();
    },
    async exportExcel() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var params = this.$refs.datatable.getExportParams();
      if (!token || !params.company_id || this.exporting_excel) {
        return
      }
      const headers = {
        "Authorization": "Bearer "+token,
      };
      this.exporting_excel = true
      this.$commonFuction.is_loading(true);
      try {
        // api trả về path file trước, sau đó 3s gọi check 1 lần cho tới khi file export xong
        var {data} = await ApiRepository.post("/_api/sra/export_sra", {filters: params.filters, company_id: params.company_id}, {headers});
        var path = data.data ? data.data.path : null
        if (!path) {
          throw new Error('no path')
        }
        var finished = false
        while (!finished) {
          await new Promise(resolve => setTimeout(resolve, 3000))
          var res = await ApiRepository.post("/_api/sra/check_export_file", {path: path, company_id: params.company_id}, {headers});
          var result = res.data.data ?? {}
          if (result.status == 'done') {
            finished = true
            // tải file về luôn, không mở tab mới
            var link = document.createElement('a')
            link.href = result.linkExcel
            link.download = ''
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else if (result.status == 'error') {
            throw new Error('export error')
          }
        }
      } catch (e) {
        console.error("Lỗi xuất excel:", e)
        this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Xuất file excel thất bại', life: 5000 })
      } finally {
        this.$commonFuction.is_loading(false);
        this.exporting_excel = false
      }
    },
    emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.offset = value;
      this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
            if (this.offset > 0) {
              this.items.push(...res.data.data.company);
            } else {
              this.items = res.data.data.company;
            }
            this.total = res.data.data.total;
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        // this.company_id = this.$store.getters?.company_id;
        // console.log("this.company",this.company)
        // await this.getListFactory();
        // this.componentKey++
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.list_sra && that.$store.getters.controllers?.list_sra.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `list-sra/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        if (that.$store.getters.controllers?.list_sra && that.$store.getters.controllers?.list_sra.includes('view')) {
          buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-sra/view/`};
        }
        if (that.$store.getters.controllers?.list_sra && that.$store.getters.controllers?.list_sra.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-sra/edit/`};
        }
        if (that.$store.getters.controllers?.list_sra && that.$store.getters.controllers?.list_sra.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
        }
        if (that.$route.query.is_fix == '1') {
          buttons.delete_fix = {name: 'delete_fix', icon: 'trash', key: 'id'};
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    //   var attributes = [];
    //   for (let index = 0; index < fields.length; index++) {
    //     const element = fields[index];
    //     if (element.models !== undefined && element.models !== null) {
    //       // console.log("SDFGHJK",element)
    //       var optionsData = [];
    //       attributes.push(element.models.key.key);
    //       attributes.push(element.models.display_key);
    //       var where_ = {}
    //       if( element['name']== "name_country"){
    //         // console.log("element",element)
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList("country", {"fields" : "id country_lang{lang name}"}),
    //           variables: {
    //             where_key : {
    //               deleted : {_eq: false}
    //             },
    //             orderBy:[{ordinal: 'desc'},{created_at : 'desc'}]
    //           }
    //         })
    //         if (data) {
    //           var ress = data[Object.keys(data)];
    //           if (ress) {
    //             for (let index = 0; index < ress.length; index++) {
    //               const ele = ress[index];
    //               var name_country = ''
    //               if(ele.country_lang){
    //                 for (let j = 0; j < ele.country_lang.length; j++) {
    //                   if(ele.country_lang[j].lang == 'en'){
    //                     name_country = ele.country_lang[j].name;
    //                     break;
    //                   }
    //                 }
    //               }
    //               if(name_country !== ''){
    //                 optionsData.push({value: ele.id, label: name_country})
    //               }
    //             }
    //           }
    //         }
    //       }else{
    //         let {data} = await this.$apollo.query({
    //           query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
    //           variables: {where_key : where_}
    //         })
    //         if (data) {
    //           var result = data[Object.keys(data)];
    //           if (result) {
    //             for (let index = 0; index < result.length; index++) {
    //               const ele = result[index];
    //               optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
    //             }
    //           }
    //         }
    //       }
    //       // console.log("optionsData",optionsData)
    //       this.options[element.key] = optionsData;
    //     }
    //     this.componentKey++;
    //   }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          // console.log("okokoakoskdaok",action.path + data.data[action.key])
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] ,query: {company_id: this.company?.id }})
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'delete_fix':
          this.deleteFixId = data.data[action.key]
          this.showDeleteFixDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/sra/delete", {id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.componentKey += 1;
          that.$toast.add({
            severity: 'success',
            summary: that.$constants.MSG_TEXT.TITLE_SUCCESS_DIALOG,
            detail: 'Xóa gói công việc thành công!',
            life: 3000
          })
        }).catch((err) => {
          console.log(err.response.data);
          if(err.response.data && err.response.data.message == 'CAN_NOT_DELETE_BY_STATUS'){
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: 'Gói công việc này đang có trạng thái không thể xóa!',
              life: 3000
            })
          }else if(err.response.data && err.response.data.message == 'CAN_NOT_DELETE_ERR'){
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: 'Gói công việc này đã tồn tại nhân sự bạn không thể xóa!',
              life: 5000
            })
          }else{
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
            })
          }
        })
      }
    },
    async deleteDataFix() {
      this.showDeleteFixDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/sra/delete_fix", {id: that.deleteFixId, company_id: that.company.id}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          console.log(err.response.data);
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          })
        })
      }
    },
    async onEventOptions({event, key, data}) {
      console.log(key);
      if (key == "department") {
        this.factory = null;
        this.factory_obj = data;
        if (event == 'offset') {
          await this.getListFactory();
        }
      }
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["factory_id"] = [];
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.factory_obj.loading = true;
        this.factory_obj.filters.company_id = this.company.id;
        await ApiRepository.post("/_api/factory/options", {filters: this.factory_obj.filters, limit: this.factory_obj.limit, offset: this.factory_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.factory_obj.offset > 0 ) {
            this.factory_obj.items.push(...res.data.data.factory);
          } else{
            this.factory_obj.items = res.data.data.factory;
          }
          // console.log("res.data.data.factory",res.data.data.factory)
          this.factory_obj.total = res.data.data.total;
          this.factory_obj.loading = false;
          this.options["factory"] = this.factory_obj;
          // console.log("this.options==2222", this.options)
        }).catch((err) => {
            console.log(err);
            this.factory_obj.loading = false;
        })
      }
      // console.log("this.options==", this.options)
    },
    async defaultFilter() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var object = {
          id : this.contractor_id,
          company_id: this.company.id
        }
        var data = null
        await ApiRepository.post("/_api/contractor/detail", object, {headers}).then(async (res) => {
          data = res.data.data
        })
        // console.log("data===",data)

        if(data){
          var contractor_name = data.name
          var obj = {
            contractor_name : contractor_name,
          }
          // console.log("obj==",obj)
          this.filters =obj
          console.log("this.filters======",this.filters)
        }
      }
      // this.componentKey++;
    },
    async openBlacklistDialog() {
      await this.loadBlacklistData();
    },
    async loadBlacklistData() {
      await new Promise(resolve => setTimeout(resolve, 3000));
      if (this.$store.getters.controllers?.list_sra && this.$store.getters.controllers?.list_sra.includes('blacklist')) {
        if (this.$commonFuction.isEmptyObject(this.company)) {
          this.blacklistData = [];
          return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
              "Authorization": "Bearer "+token,
          };
          this.blacklistLoading = true;
          await ApiRepository.post("/_api/users/contractor_users_blacklist", {
            filters: {},
            limit: 500,
            offset: 0,
            company_id: this.company.id
          }, {headers}).then((res) => {
            const list = res?.data?.data?.list ?? [];
            this.blacklistData = list.map((item) => ({
              fullname: item.fullname,
              id_card: item.id_card,
              contractor_name: item.contractor?.name ?? '',
              sra_name: item.sra?.name ?? ''
            }));
            this.blacklistLoading = false;
            const blacklist_num = res?.data?.data?.blacklist_num ?? 0
            if (blacklist_num > 0 && this.blacklistData.length > 0){
              this.showBlacklistDialog = true;
            }
          }).catch((err) => {
            console.log(err);
            this.blacklistLoading = false;
            this.blacklistData = [];
            this.$toast.add({
              severity: 'error',
              summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: 'Không tải được danh sách blacklist',
              life: 3000
            })
          })
        }
      }
    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
.sra-title-wrap{
  position: relative;
}
.sra-export-btn{
  position: absolute;
  right: 0;
  top: -4px;
}
.blacklist-action{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}
.blacklist-empty{
  text-align: center;
  padding: 16px 0;
}
</style>
